export default __webpack_public_path__ + "static/media/6.dff7c77b.png";